import type { BreadcrumbItemProps } from "./breadcrumb-item.type";

import { Flex, Tooltip } from "antd";
import { Link } from "react-router";

import ModelIcon from "@/modules/model-icon";
import { StateTag } from "@/modules/state-tag";
import { toEllipsis } from "@/utilities/string";

const BreadcrumbItem = ({ item, hideIcon, ellipsis }: BreadcrumbItemProps) => {
  const { title, href, state, model, ...itemOptions } = item;

  const showIcon = !hideIcon && !itemOptions.hideIcon;

  const text =
    ellipsis && title.length > 50 ? (
      <Tooltip title={title}>{toEllipsis(title, 50)}</Tooltip>
    ) : (
      title
    );

  return (
    <Flex gap="small">
      {state && <StateTag value={state.value} type={state.type} />}
      {showIcon && <ModelIcon model={model} />}
      {href ? <Link to={href}>{text}</Link> : text}
    </Flex>
  );
};

export default BreadcrumbItem;
